import React, { useState } from 'react';
import Proptypes from 'prop-types';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import { useGlobalData } from '../../context/globalData';
import useOnUpdate from '../../hooks/useOnUpdate';

function TabsComponent(props) {
  const { setCurrentTab } = useGlobalData();
  const { tabConfig, className, type, settings } = props;
  const [activeTab, setActiveTab] = useState(0);
  const tabsQty = settings?.tabs_qty ?? 1; 

  if (tabConfig[activeTab]?.color) {
    const root = document.querySelector(':root');
    root.style.setProperty('--lang', tabConfig[activeTab].color);
  }

  useOnUpdate(() => {
    if (type === 'lang') {
      setCurrentTab({
        label: tabConfig[activeTab]?.title,
        id: tabConfig[activeTab]?.id,
        systemRuning: tabConfig[activeTab]?.systemRuning,
      });
    }
  }, [activeTab, tabConfig]);

  return (
    <Tabs
      className={`${className}`}
      selectedIndex={activeTab}
      onSelect={(index) => {
        setActiveTab(index);
      }}
    >
      {tabConfig.length > 0 && (
        <TabList className="nav">
          {tabConfig.map((item) => (
            // <Tab style={20 / settings.tabs_qty}  data-status={item.status} key={`${item.title}_header_${item.id}`}>
            //   {item.title}
            // </Tab>

            // width of tabs depends of tabs qty
            <Tab style={{
              width: `${20 / tabsQty}px`,
              minWidth: `${(window.innerWidth / 5) / tabsQty}px`,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }} data-status={item.status} key={`${item.title}_header_${item.id}`}>
              {item.title}
            </Tab>
          ))}
        </TabList>
      )}
      {tabConfig.length > 0 ? (
        <div className="panel relative">
          {tabConfig.map((item) => (
            <TabPanel key={`${item.title}_content_${item.id}`}>{item.content}</TabPanel>
          ))}
        </div>
      ) : (
        <span>Aucune donnée.</span>
      )}
    </Tabs>
  );
}

TabsComponent.propTypes = {
  tabConfig: Proptypes.array,
  className: Proptypes.string,
  type: Proptypes.string,
  settings: Proptypes.object
};

TabsComponent.defaultProps = {
  tabConfig: [],
  className: '',
  type: '',
  settings: {}
};

export default TabsComponent;
